import {
    Box,
    Table,
    Tbody,
    Tr,
    Td,
    TableContainer,
    Avatar,
    Text,
    Flex,
    Button,
    Spinner,
    VStack,
    HStack,
    useDisclosure,
    Thead,
    Th,
  } from '@chakra-ui/react';
  import React, { useEffect, useState } from 'react';
  import { BiDotsVerticalRounded } from 'react-icons/bi';
  import { useData } from '../../../data';
  import moment from 'moment';
  import SearchBar from '../../../components/searchbar/SearchBar';
  import Header from '../../../components/header/Header';
  import { RiDeleteBin6Line } from 'react-icons/ri';
  import { FiPause, FiPlay } from 'react-icons/fi';
  import { mutateFunction, useMutation } from '../../../libs/apis';
  import { CustomToast } from '../../../components/toast/CustomToast';
  import ViewNews from './ViewNews';
  import BrandButton from '../../../components/brandButton/BrandButton';
  import AddNews from './AddNews';
  import { useSelector } from 'react-redux';
  import PermissionBlinder from '../../../components/PermissionBlinder';
import client from '../../../libs/client';
import { BASE_URL } from '../../../helpers/constant';
import { FaPenAlt } from 'react-icons/fa';
  
  const News = () => {

    const { data, isLoading, refetch } = useData(
        `news?page_no=1`,
    );
    const [news, setNews] = useState(data?.data?.news || []);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(data?.data?.totalPages || 1);

    const fetchNews = async (page_no = 1) => {
        try {
            return client()
            .get(
                `${BASE_URL}news?page_no=${page_no}&page_size=10`,
            )
            .then((res) => {
                // setIsLoading(true);
                let data = res.data;
                
                setNews(data.data.news);
                setTotalPages(data.data.totalPages);
            });
        } catch (err) {
          console.error("Error fetching news", err);
        }
    };
    const { isOpen: newsDetailsIsOpen, onToggle: onToggleOfferDetails } =
      useDisclosure();
    const { isOpen: addNewsIsOpen, onToggle: onToggleAddNews } =
      useDisclosure();
    const [selectedNews, setSelectedNews] = useState(null);
    const { mutate } = useMutation(mutateFunction);
    const { addToast } = CustomToast();
    const permissions = useSelector(
      (state) => state?.user?.userInfo?.permissions,
    );
  
    const accountType = useSelector(
      (state) => state?.user?.userInfo?.userTypeTitle,
    );
  
    const addNews = () => {
      onToggleAddNews();
    };

  
    const changeStatus = (offerId) => {
      mutate(
        { key: `offers/${offerId}`, method: 'patch' },
        {
          onSuccess(res) {
            addToast(res);
            refetch();
          },
        },
      );
    };
    const deleteNews = (offerId) => {
      mutate(
        { key: `news/${offerId}`, method: 'delete' },
        {
          onSuccess(res) {
            addToast(res);
            fetchNews();
          },
        },
      );
    };
    const viewOffer = (news) => {
      setSelectedNews(news);
      onToggleOfferDetails();
    };
  

    useEffect(() => {
        fetchNews();
    }, [page]);

    if (permissions && !permissions?.can_manage_news) {
      return <PermissionBlinder />;
    }

  
    return (
      <Box>
        <Header title="News" />
  
        {!addNewsIsOpen && !newsDetailsIsOpen &&
          (accountType === 'admin' ||
            (permissions && permissions?.can_manage_news)) && (
            <Box
              display={'flex'}
              justifyContent={'flex-end'}
              paddingTop={10}
              paddingRight={10}
            >
              <BrandButton text="Add New" w="120px" onClick={addNews} />
            </Box>
          )}
  
        {!isLoading ? (
          <>
            {newsDetailsIsOpen && (
              <ViewNews
                refetch={fetchNews}
                news={selectedNews}
                newsId={selectedNews?.id}
                onToggle={onToggleOfferDetails}
                deleteNews={deleteNews}
              />
            )}
            {addNewsIsOpen && (
              <AddNews onToggle={onToggleAddNews} refetch={fetchNews} />
            )}
            {!newsDetailsIsOpen && !addNewsIsOpen && (
              <>
                {/* --------------------table */}
                <TableContainer
                  mt="50px"
                  borderRadius="10px"
                  maxH="600px"
                  overflowY="auto"
                  className="hide-scroll"
                >
                  <Table variant="simple" size="sm" fontSize="12px">
                    <Thead>
                      <Tr>
                        <Th>Title</Th>
                        <Th>Description</Th>
                        <Th>Url</Th>
                        <Th>Created At</Th>
                        <Th>Action</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {news.map((item) => {
                        return (
                          <Tr
                            key={item.id}
                            style={{ padding: '2rem 2rem', height: '80px' }}
                            boxShadow="md"
                            borderRadius="10px"
                            _hover={{
                              borderWidth: '2px',
                              borderColor: 'brand.primary',
                              borderRadius: '10px',
                            }}
                          >
                            <Td>
                              <Flex alignItems="center">
                                <Text>{`${item?.title}`}</Text>
                              </Flex>
                            </Td>
  
                            <Td>
                              <VStack alignItems={'start'}>
                                <Text
                                  fontSize="16px"
                                  className="text-ellipsis max-w-[20ch] overflow-hidden"
                                >
                                  {item?.description}
                                </Text>
                              </VStack>
                            </Td>

                            <Td>
                              <VStack alignItems={'start'}>
                                <Text
                                  fontSize="16px"
                                  className="text-ellipsis max-w-[20ch] overflow-hidden"
                                >
                                  {item?.url}
                                </Text>
                              </VStack>
                            </Td>
  
                            <Td cursor="pointer">
                              <VStack
                                justifyContent="center"
                                alignItems="flex-start"
                              >
                                <Text fontSize="12px" color="gray">
                                  Added on{' '}
                                  {moment(item?.createdAt).format(`MMM D, YYYY`)}
                                </Text>
                              </VStack>
                            </Td>
                            <Td>
                              <Box className='flex gap-2 items-center'>
                                <Box
                                  cursor="pointer"
                                  onClick={() => viewOffer(item)}
                                  border="1px"
                                  borderColor="brand.primary"
                                  borderRadius="5px"
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  w="40px"
                                  h="40px"
                                >
                                  <FaPenAlt color="#134A70" />
                                </Box>
                                <Box
                                  cursor="pointer"
                                  onClick={() => deleteNews(item.id)}
                                  border="1px"
                                  borderColor="red"
                                  borderRadius="5px"
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  w="40px"
                                  h="40px"
                                >
                                  <RiDeleteBin6Line color="red" />
                                </Box>
                              </Box>
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>

                <div className="flex justify-center w-full mt-8 space-x-2">
                    <button
                        disabled={page === 1}
                        onClick={() => setPage((p) => p - 1)}
                        className="px-3 py-1 border rounded disabled:opacity-50"
                    >
                        Prev
                    </button>
                    <span className="px-3 py-1">{page || 1} / {totalPages || 1}</span>
                    <button
                        disabled={page === totalPages}
                        onClick={() => setPage((p) => p + 1)}
                        className="px-3 py-1 border rounded disabled:opacity-50"
                    >
                     Next
                    </button>
                </div>
              </>
            )}
          </>
        ) : (
          <>
            <Spinner m={5} />
          </>
        )}
      </Box>
    );
  };
  
  export default News;
  